<template>
  <div class="d-flex w-100">

    <el-dialog width="450px" top="5vh" title="Giao công việc mới" v-if="isShowCreateTodoDialog"
               :visible.sync="isShowCreateTodoDialog" :destroy-on-close="true" :close-on-click-modal="false">
      <CreateTodo @loadTodoList="getAllToDoList()" :account-selected="selectedAccount"
                  @closeDialog="isShowCreateTodoDialog=false" />
    </el-dialog>
    <div class="p-2 w-100 d-flex  ">
      <div class=" " style="flex:5; border-right: 1px solid #e0e4e8;margin-top: -0.5rem; margin-bottom: -0.5rem">
        <div class="mt-3 d-flex justify-content-center align-items-center">
          <div class="font-size-18 ">Chọn tài khoản</div>
          <el-select filterable @change="changeAccount" v-model="accountId" placeholder="Chọn tài khoản"
                     size="mini"
                     class="  mx-2">
            <el-option v-for="account in app.accounts" :key="account.accountId" :label="getAccountName(account)"
                       :value="account.accountId"></el-option>
          </el-select>
          <div class="ms-auto d-flex">
            <div class="position-relative">
              <el-input
                placeholder="Tìm công việc"
                v-model="app.highlightTask">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
              <!--              <div  class="position-absolute mt-1 align-self-end font-size-13 pointer icon-hover" style="color: #7589A3;right:0">Tìm kiếm nâng cao</div>-->
            </div>

            <el-button type="primary" @click="isShowCreateTodoDialog=true" class="ms-1 px-2 me-2" style="height: 40px">
              <i class="el-icon-plus"
                 size="mini"></i>
              Giao việc mới
            </el-button>
          </div>
        </div>
        <div class="mt-3">
          <div style="">
            <el-tabs v-model="nameTab">
              <!--              <el-tab-pane name="creator" :label="'Tôi giao'+'('+ getTodoCreatorSize+ ')'">-->
              <el-tab-pane name="creator" :label="'Tôi giao'">
                <ZaloTodo :selectedAccount="selectedAccount" :role="role.creator" :data_list="viewFilter" />
              </el-tab-pane>
              <!--              <el-tab-pane name="assginees" :label="'Cần làm'+'('+ getTodoAssgineesSize+ ')'">-->
              <el-tab-pane name="assginees" :label="'Cần làm'">
                <ZaloTodo :selectedAccount="selectedAccount" :role="role.assignees" :data_list="viewFilter" />
              </el-tab-pane>
              <!--              <el-tab-pane name="watchers" :label="'Theo giõi'+'('+ getListWatchers+')'">-->
              <!--                <ZaloTodo :data_list="viewFilter" />-->
              <!--              </el-tab-pane>-->
            </el-tabs>
          </div>
        </div>
      </div>
      <div style="flex:2" class="p-2">
        <div style="height: 60px" class="p-2 justify-content-between d-flex  align-items-start">
          <div class="fw-bolder font-size-16">Lịch sử hoạt động</div>
          <img src="/assets/icon/graph.svg" />
        </div>
      </div>

    </div>

  </div>
</template>

<script>

import ZaloTodo from "../components/todo/ZaloTodo";
import CreateTodo from "../components/todo/CreateTodo";

export default {
  name: "ZaloTodoPage",
  components: { CreateTodo, ZaloTodo },
  data() {
    return {
      accountId: "",
      nameTab: "creator",
      /*   hasLoadMore: {
           creator: false,
           assignees: false,
           watchers: false,
           scrollIdCreator: "",
           scrollIdAssignees: "",
           scrollIdWatchers: ""
         },*/
      isShowCreateTodoDialog: false,
      accounts: [],
      selectedAccount: { accountId: "" },
      listTodoCreator: [],
      listTodoAssignees: [],
      listTodoWatchers: [],
      role: {
        creator: "creator",
        assignees: "assignees",
        watchers: "watchers"
      }
    };
  },
  computed: {
    getListWatchers() {
      let size = this.listTodoWatchers.length;
      if (size > 99) return "99+";
      return size;
    },
    getTodoCreatorSize() {
      let size = this.listTodoCreator.filter(s => s.status === -1 || s.status === 0).length;
      if (size > 99) return "99+";
      return size;
    },
    getTodoAssgineesSize() {
      let size = this.listTodoAssignees.filter(s => s.status === -1 || s.status === 0).length;
      if (size > 99) return "99+";
      return size;
    },
    viewFilter() {
      if (this.app.highlightTask.trim().length > 0) {
        if (this.nameTab === "creator") {
          return this.listTodoCreator.filter(s => s.content.toLowerCase().includes(this.app.highlightTask.trim().toLowerCase()) || s.description.toLowerCase().includes(this.app.highlightTask.trim().toLowerCase()));
        } else if (this.nameTab === "assginees") {
          return this.listTodoAssignees.filter(s => s.content.toLowerCase().includes(this.app.highlightTask.trim().toLowerCase()) || s.description.toLowerCase().includes(this.app.highlightTask.trim().toLowerCase()));
        } else {
          return this.listTodoWatchers.filter(s => s.content.toLowerCase().includes(this.app.highlightTask.trim().toLowerCase()) || s.description.toLowerCase().includes(this.app.highlightTask.trim().toLowerCase()));
        }
      } else {
        if (this.nameTab === "creator") {
          return this.listTodoCreator;
        } else if (this.nameTab === "assginees") {
          return this.listTodoAssignees;
        } else {
          return this.listTodoWatchers;
        }
      }
    }
  },
  methods: {

    getAllToDoList() {
      this.listTodoAssignees = [];
      this.listTodoCreator = [];
      this.listTodoWatchers = [];
      this.getToDoList(this.role.creator);
      this.getToDoList(this.role.assignees);
      // this.getToDoList(this.role.watchers);
    },
    getToDoList(role, scrollId = "", offset = 0) {
      let queries = JSON.stringify({ role: role });
      let request = {
        accountId: this.selectedAccount.accountId,
        scrollId: scrollId,
        offset: offset,
        limit: 50,
        queries: queries,
        type: 1
      };
      this.$http.post("/api/todo/getTodoList", request).then(resp => {
        let data = resp.data.data;
        if (!Array.isArray(data)) {
          let data_list = data.data_list;
          if (role === this.role.creator) {
            // this.hasLoadMore.creator = data.totalItems >= 50;
            // this.hasLoadMore.scrollIdCreator = data.scrollId;
            data_list.forEach(s => s.statusTodo = 0);
            this.listTodoCreator.push(...data_list);
            this.listTodoCreator = this.listTodoCreator.sort((b, a) => a.updateTime - b.updateTime);
          }
          if (role === this.role.assignees) {
            // this.hasLoadMore.assignees = data.totalItems >= 50;
            // this.hasLoadMore.scrollIdAssignees = data.scrollId;
            data_list.forEach(s => s.statusTodo = 1);
            this.listTodoAssignees.push(...data_list);
            this.listTodoAssignees = this.listTodoAssignees.sort((b, a) => a.updateTime - b.updateTime);
          }
          if (role === this.role.watchers) {
            // this.hasLoadMore.watchers = data.totalItems >= 50;
            // this.hasLoadMore.scrollIdWatchers = data.scrollId;
            data_list.forEach(s => s.statusTodo = 2);
            data_list.forEach(s => {
              // if (s.dueDate === -1 || s.dueDate > new Date().getTime() || s.status === 1) {
              this.listTodoWatchers.push(s);
              // }
            });

            this.listTodoWatchers = this.listTodoWatchers.sort((b, a) => a.updateTime - b.updateTime);

          }
          // let totalItems = data.totalItems;
          // let scrollId = data.scrollId;
          // if (totalItems === 50 && scrollId.length > 0) {
          //   this.getToDoList(role, scrollId);
          // }

        }
      });
    },
    changeSortType() {
      this.app.listContactsAccount = this.app.listContactsAccount.sort((a, b) => {
        if (a.displayName.toLowerCase() > b.displayName.toLowerCase()) return 1;
        if (a.displayName.toLowerCase() < b.displayName.toLowerCase()) return -1;
        return 0;
      });
    },
    getContact() {
      this.$http
        .get("/api/contact/filter", {
          params: {
            searchKey: "",
            accountId: this.selectedAccount.accountId,
            page: 0,
            pageSize: 10000
          }
        })
        .then(resp => {
          this.app.listContactsAccount = resp.data.content;
          this.changeSortType();
        });
    },
    changeAccount() {
      this.selectedAccount = this.app.accounts.find(s => s.accountId === this.accountId);
      this.getAllToDoList();
      this.getContact();
    },
    getAccountList() {
      return this.$http.get("/api/account/getAll").then(resp => {
        this.accounts = resp.data;
        return resp.data;
      });
    },
    deleteItem(data) {
      let index = this.listTodoCreator.findIndex(s => s.id === data.id);
      if (index !== -1) {
        this.listTodoCreator.splice(index, 1);
      }
      let indexA = this.listTodoAssignees.findIndex(s => s.id === data.id);
      if (indexA !== -1) {
        this.listTodoAssignees.splice(indexA, 1);
      }
    }
  },
  mounted() {
    this.$bus.$on("updateTask", data => {
      this.isShowCreateTodoDialog = false;
      if (!data) return;

      if (["delete", "reject"].includes(data.action)) {
        return this.deleteItem(data);
      }


      if (data.statusTodo === 0) {
        data.role = this.role.creator;
        this.listTodoCreator = [];
      } else if (data.statusTodo === 1) {
        data.role = this.role.assignees;
        this.listTodoAssignees = [];
      } else {
        data.role = this.role.watchers;
        this.listTodoWatchers = [];
      }
      this.getToDoList(data.role, data.scrollId, 0);
    });
    /* this.$bus.$on("loadMoreTodo", data => {
       this.getToDoList(data.role, data.scrollId, 0);
     });*/
  },
  beforeDestroy() {
    this.$bus.$off("updateTask");
  },
  created() {
    this.getAccountList().then(data => {
      if (data.length === 0) return;
      this.accountId = data[0].accountId;
      this.selectedAccount = data[0];
      this.getAllToDoList();
      this.getContact();
    });

  }
};
</script>

<style scoped>
.icon-hover:hover {
  color: #0A58C0;
}
</style>
